import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import CustomSID from "../CustomSID";
import { RESULT_STATE } from "constant";
import i18n from "i18next"
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

const CustomMultipleSIDHover = ({
  data,
  indexParent,
  emergency = false,
  placement = "top",
  showTooltip = true,
  t,
  isShowState = false,
}) => {
  //--const t = (msg, param) => i18n.t(msg, param)
  const [sampleIds, setSampleIds] = useState([])
  const [sampleDistinct, setSampleDistinct] = useState([]);
  useEffect(() => {
    let sids = (data != '' && data != null) ? JSON.parse(data) : []
    setSampleIds(sids)
    const sid = sids.map(x => `${x.SID}${x.SubSID ? ` - ${x.SubSID}` : ''}`.trim())
    const sidDistinct = sid.filter((x, index) => !sid.includes(x, index + 1)) || []
    setSampleDistinct(sidDistinct)
  }, [data])

  return (
    <>
      <div className="floating-text-field">
      {sampleDistinct.map((item, index) => {
          const tooltipId = `tooltip_sid_${indexParent}_${index}`;
          
          return (
            <React.Fragment key={index}>
              {/* Element hiển thị tooltip khi hover */}
              <span data-tip data-for={tooltipId}>
                <CustomSID sid={item} emergency={emergency} />
              </span>

              {/* Tooltip hiển thị thông tin mẫu */}
              <ReactTooltip id={tooltipId} place={placement} effect="solid">
                {sampleIds
                  .filter((x) => `${x.SID}${x.SubSID ? ` - ${x.SubSID}` : ""}`.trim() === item)
                  .map((x, indexChild) => {
                    let stateStr = "";
                    if (x.State && isShowState) {
                      stateStr = ` - ${t(RESULT_STATE[x.State])}`;
                    }
                    return (
                      <div key={indexChild} style={{ whiteSpace: "nowrap" }}>
                        {`${x.SampleTypeName} - ${x.SampleType}${stateStr}`}
                      </div>
                    );
                  })}
              </ReactTooltip>
            </React.Fragment>
          );
        })}
      </div>
    </>
  )
}

CustomMultipleSIDHover.propTypes = {
  data: PropTypes.string,
  indexParent: PropTypes.number
}

CustomMultipleSIDHover.defaultProps = {
  data: '',
  indexParent: 1
}

const mapStateToProps = ({ }) => ({

})

const mapDispatchToProps = dispatch => ({

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["testResultPage", "common"])(CustomMultipleSIDHover))